var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.96552 1H3.2069C1.98806 1 1 1.98806 1 3.2069V14.7931C1 16.012 1.98806 17 3.2069 17H14.7931C16.012 17 17 16.012 17 14.7931V12.0345M17 5.96552V1H12.0345M16.7241 1.27586L8.72414 9.27586",
    stroke: "url(#paint0_linear_5155_73013)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5155_73013",
    x1: 1,
    y1: 8.8546,
    x2: 17,
    y2: 8.8546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D61D6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7645FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.14e1ae11898b868d331cd7499fe75857.svg";
export { ForwardRef as ReactComponent };